module.exports = __webpack_public_path__ + "img/md_one.dc6121a9.png";